angular.module('rjmNg.common.api').constant 'JOBS', Object.freeze

  SOURCES:
    THIRD_PARTY: 'thirdParty'
    DATABASE: 'database'

  STATUSES:
    SUCCESS: "success"
    IN_PROGRESS: "in_progress"
    CONNECTOR_ERROR: "connector_error"
    AUTH_ERROR: "auth_error"
    IAPI_ERROR: "iapi_error"
    INTERRUPTED: "interrupted"
    THIRD_PARTY_ERROR: "third_party_error"
    PENDING_INTERRUPT: "pending_interrupt"
    COMPLETE: "COMPLETE"

  DB_STATUSES:
    TRIGGERED: "TRIGGERED"
    QUEUED: "QUEUED"
    SKIPPED: "SKIPPED"
    IN_PROGRESS: "IN_PROGRESS"
    COMPLETE: "COMPLETE"
    FAILED: "FAILED"
